<script setup>
// [NA-PATCH] View de casca do CRM Rampa: hospeda o crm-app (serviço
// próprio, same-origin em /crm-app/) dentro do dashboard. Toda a
// lógica de CRM vive fora deste repositório — este arquivo é apenas
// a porta de entrada. Ver na-crm-app/docs e PLANO-CRM-KANBAN.md.
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const crmUrl = computed(
  () => `/crm-app/?account_id=${route.params.accountId}&embed=1`
);
</script>

<template>
  <div class="flex h-full w-full flex-1 overflow-hidden">
    <iframe :src="crmUrl" title="CRM" class="h-full w-full border-0" />
  </div>
</template>
